/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { getCurrentUserUrl, updateCurrentUserUrl } from '@modules/cloud-api/v1/urls'
import type { User } from '@modules/cloud-api/v1/types'
import type { DeepPartial } from '@modules/ts-essentials'

import asyncRequest, { resetAsyncRequest } from '../asyncRequests'
import { FETCH_CURRENT_USER, UPDATE_CURRENT_USER } from '../../constants/actions'

export function fetchCurrentUser() {
  const url = getCurrentUserUrl()

  return asyncRequest<typeof FETCH_CURRENT_USER, User>({
    type: FETCH_CURRENT_USER,
    url,
  })
}

export function updateCurrentUser(
  user: DeepPartial<User>,
  crumb: 'change_password' | 'update_profile',
) {
  const url = updateCurrentUserUrl()

  return asyncRequest<typeof UPDATE_CURRENT_USER, User>({
    type: UPDATE_CURRENT_USER,
    method: 'PATCH',
    url,
    payload: user,
    crumbs: [crumb],
  })
}

export function resetFetchCurrentUser() {
  return resetAsyncRequest(FETCH_CURRENT_USER)
}
